/** Colour and INI numeric helpers, ported from YKnyttLib.KnyttUtil. */

/** Convert a Knytt BGR-encoded integer to an [r,g,b] tuple (0..255). */
export function bgrToRgb(kc: number): [number, number, number] {
  const r = 0xff & kc;
  const g = (0xff00 & kc) >> 8;
  const b = (0xff0000 & kc) >> 16;
  return [r, g, b];
}

/** Convert a Knytt BGR-encoded integer to a 0xRRGGBB number (for Pixi tint). */
export function bgrToRgbNumber(kc: number): number {
  const [r, g, b] = bgrToRgb(kc);
  return (r << 16) | (g << 8) | b;
}

/** C# Math.Round: round half to even (banker's rounding). */
function roundHalfToEven(n: number): number {
  const floor = Math.floor(n);
  const diff = n - floor;
  if (diff > 0.5) return floor + 1;
  if (diff < 0.5) return floor;
  return floor % 2 === 0 ? floor : floor + 1;
}

/**
 * Parse a leading numeric value from an INI string the way Knytt does:
 * take leading digits / sign / dot, parse as float, round to int
 * (C# Math.Round = half-to-even).
 */
export function parseIniInt(value: string | null | undefined): number | null {
  if (value == null) return null;
  let s = '';
  for (const c of value) {
    if ((c >= '0' && c <= '9') || c === '-' || c === '+' || c === '.') s += c;
    else break;
  }
  if (s === '' || s === '-' || s === '+' || s === '.') return null;
  const n = Number(s);
  return Number.isNaN(n) ? null : roundHalfToEven(n);
}

/** parseBGRString — returns parsed int or a default. */
export function parseBgrString(value: string | null | undefined, def: number): number {
  const n = parseIniInt(value);
  return n == null ? def : n;
}

export function clamp(v: number, lo: number, hi: number): number {
  return v < lo ? lo : v > hi ? hi : v;
}

/** Move `current` toward `target` by at most `maxDelta` (Godot MathTools.MoveTowards). */
export function moveTowards(current: number, target: number, maxDelta: number): number {
  if (Math.abs(target - current) <= maxDelta) return target;
  return current + Math.sign(target - current) * maxDelta;
}
